import React, { PropTypes } from 'react'

class Home extends React.Component {
  render () {
      return (

          <h1>欢迎！</h1>

      )
  }
}

export default Home;



/** WEBPACK FOOTER **
 ** src/home.js
 **/